import dayjs from "dayjs";
require("dayjs/locale/ru");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);

const dateFilter = (value, format = "YYYY-MM-DD") => {
  return dayjs(value)
    .tz("Europe/Moscow")
    .locale("ru")
    .format(format);
};

const getWeek = d => {
  d = d ? new Date(d) : new Date();
  // Get last Sunday
  d = d.getDate() - ((d.getDay() + 7) % 7);

  let start = new Date();
  let end = new Date();
  start.setDate(d);
  end.setDate(d + 8);
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  return { start, end };
};

const splitDateTime = timestamp => {
  let date, time;
  // Firebase Timestamp to Date obj
  const d = timestamp.toDate();
  date = dayjs(d).format("YYYY-MM-DD");
  time = dayjs(d).format("HH:mm");

  return { date, time };
};

export { dateFilter, getWeek, splitDateTime };
